module.exports = "/static/assets/f3cd3bde88a384bf6757c9f30508cdd6.svg";